"use client"

import { useCallback } from "react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import Image from "next/image"
import { ArrowRight } from "lucide-react"
import { products } from "../product-catalog"

export default function ProductsSection() {
  const handleViewAllProducts = useCallback(() => {
    window.location.href = "/san-pham"
  }, [])

  const handleViewProductDetail = useCallback((productId: number) => {
    console.log(`View product ${productId}`)
  }, [])

  return (
    <section id="products" className="sm:py-16 py-16 bg-white" aria-labelledby="products-heading">
      <div className="w-screen bg-[#273647] py-8 mb-8">
        <h2 className="text-4xl md:text-5xl font-display text-white text-center">
          ỨNG DỤNG CỦA SỢI PP MULTI
        </h2>
      </div>

      <div className="container mx-auto px-4">
        <div className="text-center mb-20">
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Khám phá bộ sưu tập các sản phẩm chất lượng cao được làm từ sợi PP Multi của Sợi Cửu Long
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {products.map((product) => (
            <div key={product.id} className="h-full">
              <Card className="rounded-none overflow-hidden hover:shadow-xl transition-shadow duration-200 group border-0 shadow-lg h-full min-h-[500px] flex flex-col">
                <div className="relative h-64 overflow-hidden">
                  <Image
                    src={product.image || "/placeholder.svg"}
                    alt={`${product.name} - ${product.description}`}
                    fill
                    className="object-cover"
                    loading="lazy"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                  <Badge className="absolute top-4 left-4 bg-primary text-[#555555] font-industrial text-xs px-3 py-1">
                    {product.category}
                  </Badge>
                </div>
                <CardHeader className="pb-4 flex-grow">
                  <CardTitle className="text-secondary font-heading text-xl">{product.name}</CardTitle>
                  <CardDescription className="text-gray-600 leading-relaxed text-base">
                    {product.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            </div>
          ))}
        </div>

        {/* <div className="text-center">
          <Button
            size="lg"
            onClick={handleViewAllProducts}
            className=" text-white bg-[#273647] font-semibold px-8 py-4 text-lg font-industrial focus:outline-none"
            aria-label="Xem tất cả sản phẩm của Cửu Long YARN JSC"
          >
            XEM TẤT CẢ SẢN PHẨM
            <ArrowRight className="ml-2 h-5 w-5" aria-hidden="true" />
          </Button>
        </div> */}
      </div>
    </section>
  )
}
